module.exports = __webpack_public_path__ + "static/photo-4-ce66d7bbe82ecf24cece4c0f146553a5.jpg";